module.exports = __webpack_public_path__ + "img/nuage.d7c5a2e0.png";